<template>
  <div id="broken-line" :style="size" style="display: flex;align-items:center;flex-direction: column">
    <e-charts :size="size" style="margin-top: 50px" :options="options" />
  </div>
</template>

<script>
import ECharts from './ECharts'

export default {
  components: {
    ECharts
  },
  data: function () {
    return {
      year: 2000,
      options: {
        title: {
          // text: '2000年深圳和广州各月新冠新增情况',
          textStyle: {
            color: "rgba(255,255,255,0.9)"
          },
          left: "center",
          top: "5px"
        },
        color: ['#00f2f1', "#ed3f35"],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          top: "15%",
          right: "10%",
          // 里面的名字要与serious里面的名字保持一致
          data: ['深圳新冠', '广州新冠'],
          show: true,
          textStyle: {
            color: "rgba(255,255,255,0.6)"
          }
        },
        grid: {
          top: '30%',
          left: '10%',
          right: '10%',
          bottom: '4%',
          show: true,
          borderColor: "#012f4a",
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "rgba(255,255,255,0.7)"
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)"
            }
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.3)"
            }
          },
          axisLabel: {
            textStyle: {
              color: "rgba(255,255,255,0.6)",
              fontSize: "12"
            }
          },
        },
        series: [
          {
            name: '深圳新冠',
            type: 'line',
            // stack: 'Total',
            data: [120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90],
            smooth: true
          },
          {
            name: '广州新冠',
            type: 'line',
            // stack: 'Total',
            data: [220, 182, 191, 234, 290, 330, 310, 182, 191, 234, 290, 330],
            smooth: true
          }
        ]
      },
      size: {
        width: '100%',
        height: '300px'
      }
    }
  },
  mounted () {

  }
}
</script>

<style scoped>

</style>
